export const LEVELS = ['simple', 'standard', 'advanced'];
/** Where members start when nobody has chosen otherwise */
export const DEFAULT_LEVEL = 'standard';
/** Where guests start, whatever the organization's default */
export const GUEST_LEVEL = 'simple';
/** How far up a level is, so levels compare as numbers. */
export function levelRank(level) {
    return LEVELS.indexOf(level);
}
/** Whether someone at `level` sees what `needed` offers. */
export function reaches(level, needed) {
    return levelRank(level) >= levelRank(needed);
}
/** The lower of two levels. */
export function lowerLevel(left, right) {
    return levelRank(left) <= levelRank(right) ? left : right;
}
/** The higher of two levels. */
export function higherLevel(left, right) {
    return levelRank(left) >= levelRank(right) ? left : right;
}
/**
 * The level someone works at.  Their own choice wins, then where people of their kind start: the
 * organization's default for members and owners, and Simple for guests.  A guest never goes above
 * the highest level the organization allows guests, even with a choice made before it was set.
 */
export function levelsFor(kind, settings, choice) {
    const highest = kind === 'guest' ? (settings?.guestLevel ?? 'advanced') : 'advanced';
    const start = lowerLevel(kind === 'guest' ? GUEST_LEVEL : (settings?.defaultLevel ?? DEFAULT_LEVEL), highest);
    return { level: lowerLevel(choice ?? start, highest), highest, start, chosen: choice !== undefined };
}
//# sourceMappingURL=level-values.js.map